import "./iconAnswer.css";

interface IconAnswerProps {
  message: string;
}

const IconAnswerDashboard = ({ message }: IconAnswerProps) => {
  return (
    <div className="containerIconAnswerDash">
      <span className="mensageIconAnswer" style={{ marginTop: "5px" }}>
        <div dangerouslySetInnerHTML={{ __html: message }} />
      </span>
    </div>
  );
};

export default IconAnswerDashboard;
